import $ from 'jquery'
export default {
  name: 'modal-create-groupe-visites-medicales',
  components: {},
  props: {
    type: String
  },
  data () {
    return {
      search_word: null,
      search_word_examen: null,
       groupe: {
         is_general: 0,
         nom: "",
         societe_id: null,
         examens: [],
         analyses: []
       },
       loading: false


    }
  },
  watch: {
    search_word() {
        this.searchAnalyse()
    },
    search_word_examen(){
        this.searchExamen()
    }
  },
  computed: {
    latestVisiteEnCours(){
      return this.$store.getters["latestVisiteMedicaleAnnuelle"]
    },
  
    categoriesAnalyses() {
        return this.$store.getters["categoriesAnalyses"];
    },
    
    examens(){
      return this.$store.getters["examens"];
    }
  },
  
  mounted () {
    this.$store.dispatch("getCategoriesAnalyses");
    this.$store.dispatch("getExamens");
    this.groupe.societe_id = parseInt(this.$route.params.id) 
    

    var div_top = $('.stickanal').offset().top;

    if(this.$route.params.id === undefined){
      this.groupe.is_general = 1
      this.groupe.societe_id = 0
    } else {
      this.groupe.is_general = 0
    }

    console.log(div_top)

    $('#createGroupeVM .modal-body').on("scroll", function(){
      
      let div_top = $('.searchbox').offset().top;

      if(div_top<0){
        $("#createGroupeVM .show-on-fixed-create").fadeIn()
        $("#createGroupeVM .modal-body").addClass("pt-0")

      } else{
        $("#createGroupeVM .show-on-fixed-create").fadeOut()
        $("#createGroupeVM .modal-body").removeClass("pt-0")
      }

      
    })

  },
  methods: {

    searchAnalyse: function(){
      this.$store.dispatch('searchAnalyses',this.search_word)
      
    },
    searchExamen: function(){
      this.$store.dispatch('searchExamen',this.search_word_examen)
    },
    ajouterGroupeVisiteMedicales: function(){
      this.loading = true
      this.$store.dispatch('ajouterGroupeParametrageVM',this.groupe).then(() => {
         
         this.loading = false
         this.groupe.nom = "",
         this.groupe.examens = []
         this.groupe.analyses = []
         let societe_id = this.$route.params.id;
        
         

         if(Object.keys(this.latestVisiteEnCours).length !==0 && this.groupe.societe_id !==0){
           let data = {visite_medicale_id: this.latestVisiteEnCours.id}
           this.$store.dispatch('initVisitesMedicalesProgrammation',{societe_id: societe_id, data:data}).then(
             () => {
               this.$store.dispatch('getProgrammationsVisitesMedicales',this.latestVisiteEnCours.id)
               this.$store.dispatch('getSocieteVisiteMedicaleStats',this.latestVisiteEnCours.id)
             }
           )
         }
         
         $('.modal').modal('hide')
         this.successStoreGroupeVM()

      }, error =>{
        console.log(error)
        $('.modal').modal('hide')
        this.loading = false
        this.groupe.nom = "",
         this.groupe.examens = []
         this.groupe.analyses = []
        
        this.failureStoreGroupeVM()
      })
    },
    successStoreGroupeVM: function() {
      this.$toasted.show('le groupe a été créé avec succès', {
          duration: 3000,
          action: [{
              text: 'X',
              onClick: (e, toastObject) => {
                  toastObject.goAway(0);
              }
          }],
          theme: 'toasted-primary',
          type: 'success',
          position: 'top-center'

      })
  },
  failureStoreGroupeVM: function() {
    this.$toasted.show('le groupe existe déjà.', {
        duration: 3000,
        action: [{
            text: 'X',
            onClick: (e, toastObject) => {
                toastObject.goAway(0);
            }
        }],
        theme: 'toasted-primary',
        type: 'error',
        position: 'top-center'

    })
},
  scrolly: function(){
    var div_top = $('.stickanal').offset().top;

    console.log(div_top)

  },
  sc: function(){
    console.log('cc')
  }


  }
}


